// src/components/GridLayout.tsx

import React from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { BiSolidWidget } from "react-icons/bi";
import { Layout } from '../types/Layout';
import { WidgetContainer } from './WidgetContainer';
import './GridLayout.scss';

interface GridLayoutProps {
  layout: Layout;
  onLayoutChange: (newLayout: Layout) => void;
}

export const GridLayout: React.FC<GridLayoutProps> = ({ layout, onLayoutChange }) => {
  const handleVerticalResize = (sizes: number[]) => {
    const newGrid = [...layout.grid];
    sizes.forEach((size, index) => {
      newGrid[index].size = size;
    });
    onLayoutChange({ ...layout, grid: newGrid });
  };

  const handleHorizontalResize = (rowIndex: number, sizes: number[]) => {
    const newGrid = [...layout.grid];
    sizes.forEach((size, colIndex) => {
      newGrid[rowIndex].cells[colIndex].size = size;
    });
    onLayoutChange({ ...layout, grid: newGrid });
  };

  return (
    <div className="grid-layout">
      <PanelGroup
        direction="vertical"
        className="panel-group"
        onLayout={handleVerticalResize}
      >
        {layout.grid.map((row, rowIndex) => (
          <React.Fragment key={rowIndex}>
            {rowIndex > 0 && <PanelResizeHandle className="resize-handle-horizontal" />}
            <Panel defaultSize={row.size} minSize={0}>
              <PanelGroup
                direction="horizontal"
                className="panel-group"
                onLayout={(sizes) => handleHorizontalResize(rowIndex, sizes)}
              >
                {row.cells.map((cell, colIndex) => (
                  <React.Fragment key={colIndex}>
                    {colIndex > 0 && <PanelResizeHandle className="resize-handle" />}
                    <Panel defaultSize={cell.size} minSize={0}>
                      <div className="widget-container">
                        {cell.widgetName ? (
                          <WidgetContainer widgetName={cell.widgetName} />
                        ) : (
                          <div className="empty-widget"><BiSolidWidget size={100} /></div>
                        )}
                      </div>
                    </Panel>
                  </React.Fragment>
                ))}
              </PanelGroup>
            </Panel>
          </React.Fragment>
        ))}
      </PanelGroup>
    </div>
  );
};